import React from 'react';
import CampaignsDetailLayout from './campaigns-detail-layout';

export default class CampaignsDetail extends React.Component<{}, {}> {
    render(){
        return(
            <CampaignsDetailLayout/>
        )
    }
}